export default __webpack_public_path__ + "static/media/img3.38bebc7d.jpg";